import script from "./InvoiceTermsEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoiceTermsEditor.vue?vue&type=script&setup=true&lang=ts"

import "./InvoiceTermsEditor.vue?vue&type=style&index=0&id=10a2625c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a2625c"]])

export default __exports__